import { useQuery } from "hooks/useQuery";
import { getStockMovers } from "../service";

export const useStockMovers = (type) => {
  const { isLoading, data } = useQuery({
    queryKey: ["stockMovers", type],
    queryFn: async () => {
      const response = await getStockMovers({ type });
      return response;
    },
    enabled: Boolean(type),
  });

  return {
    isLoading,
    stockMovers: data || [],
  };
};
